<template>
  <div>
    <div>
      <el-input
        size="small"
        ref="inputMesage"
        @input="searchKeyChanged"
        v-model="searchKey"
        placeholder="Tìm kiếm tên,tài khoản ..."
        style="width: 300px"
      ></el-input>
    </div>

    <el-table :data="tagView" height="60vh" stripe
              style="width: 100%;--bs-table-hover-color:white">
      <el-table-column label="Tên" width="200">
        <template slot-scope="scope">
          <div style="white-space: pre-line" class="text-normal">
            <tag-custom :item="scope.row" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Ngày" align="center" width="160">
        <template slot-scope="scope">
          <div style="white-space: pre-line" class="text-normal">
            {{ formatDateTimeShort(scope.row.ts) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Thao tác" align="center" width="130">
        <template slot-scope="scope">
          <div style="white-space: pre-line" class="text-normal">
            {{ scope.row.type == "untag" ? "Bỏ tag" : "Gắn tag" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Tài khoản">
        <template slot-scope="scope">
          <div style="white-space: pre-line" class="text-normal">
            {{ scope.row.username }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-danger">Lưu ý (*) là tag chỉ định</div>

  </div>
</template>

<script>

import TagCustom from "../common/TagCustom";

export default {
  name: "TagHistoryPopup",
  components: { TagCustom },
  props: ["conversationId"],
  data() {
    return {
      tags: [],
      tagView: [],
      searchKey: ""
    };
  },
  methods: {
    searchKeyChanged() {
      this.showTags();
    },
    showTags() {
      if (this.searchKey.length > 0) {
        this.tagView = this.tags.filter(t => t.name.toLowerCase().includes(this.searchKey.toLowerCase()) || t.username.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.tagView = this.tags;
      }
    },
    getHistory() {
      this.tags = [];
      this.$http.get("/api/tag/history", { params: { conversationId: this.conversationId } }).then((res) => {
        res.data.data.forEach((t) => {
          let search = this.app.tags.filter(s => s.id == t.tagId);
          if (search != null && search.length > 0) {
            this.tags.push({
              username: t.username.split("/").length > 1 ? t.username.split("/")[1] : t.username,
              type: t.type,
              ts: t.ts,
              name: search[0].name + (search[0].assign ? " (*)" : ""),
              id: t.tagId,
              color: search[0].color
            });
          }
        });
        this.tags.sort((a, b) => b.ts - a.ts);
        this.showTags();
      });
    }
  },
  created() {
    this.getHistory();
  }
};
</script>

<style scoped>

</style>